import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import PipelineEditPage from '../components/PipelineEditPage'
import {
  actionCreators,
  IPipelineEditState,
  selectEditCriticalDateIndex,
  selectCheckPipelineExists,
  selectError,
  selectIsLoading,
  selectIsReady,
  selectIsSaving,
  selectPipeline,
  selectShowCriticalDateModal,
} from '../modules/pipelineEdit'

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IPipelineEditState>({
      editCriticalDateIndex: selectEditCriticalDateIndex(),
      hasExistingPipeline: selectCheckPipelineExists(),
      error: selectError(),
      isLoading: selectIsLoading(),
      isReady: selectIsReady(),
      isSaving: selectIsSaving(),
      pipeline: selectPipeline(),
      showCriticalDateModal: selectShowCriticalDateModal(),
    }),
    actionCreators,
  )(PipelineEditPage),
)
